<div class="activity_tab">
    <div class="user_details">
        <app-user-details></app-user-details>
        <app-user-photos></app-user-photos>
        <app-user-friends></app-user-friends>
        <app-quick-search></app-quick-search>
        
    </div>
    <div class="user_posts">
        <app-posts [is_activity]="isActivity"></app-posts>
         <!-- <app-posts-test></app-posts-test> -->
         
    </div>
</div>